import useTranslation from 'next-translate/useTranslation'

export function WellBeingListItem({ text }: { text: string }) {
  const { t } = useTranslation('forBrands')

  return (
    <div className="flex items-start">
      <div className="w-1.5 h-1.5 bg-black rounded-full p-1 mt-[0.6rem] mr-1.5" />
      <div>
        <p className="text-left">{t(`${text}`)}</p>
      </div>
    </div>
  )
}
